import '../styles/Modal.css';
import Swal from 'sweetalert2';
import { useEffect } from "react";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export function Modal({ isOpen, onClose }: ModalProps) {
    if (!isOpen) return null;

    const redirigir = () => {
        window.location.href = 'https://www.monterrey.gob.mx';
    };

    return (
        <div
            className="fixed inset-0 flex justify-center items-center bg-red-500/50 z-50 px-4"
        >
            <div className="bg-white w-full max-w-md rounded-lg shadow-lg">
                <div className="p-4 border-b">
                    <h5 className="text-lg font-bold">Mensaje Importante:</h5>
                </div>
                <div className="p-4 text-sm text-gray-700">
                    Para liberación de vehículos detenidos, acudir previamente a la Dirección de Tránsito de Monterrey en
                    Abraham Lincoln 300, esquina Refugio Velázquez, Col. Morelos CP 64330.
                    <br />
                    Para dudas sobre su adeudo, llámenos al <strong>81 8305 0900 Ext. 1978</strong>.
                    <p className="mt-4 text-center">¿Desea continuar en el sitio?</p>
                </div>
<div className="p-4 flex flex-col sm:flex-row gap-2">
    <button
        type="button"
        className="flex-1 bg-green-500 text-white py-2 rounded-lg hover:bg-green-600"
        onClick={onClose}
    >
        Sí
    </button>
    <button
        type="button"
        className="flex-1 bg-red-500 text-white py-2 rounded-lg hover:bg-red-600"
        onClick={redirigir}
    >
        No
    </button>
</div>

            </div>
        </div>
    );
}

export function SwalModal({ isOpen, onClose }: ModalProps) {
    if (!isOpen) return null;

    const redirigir = () => {
        window.location.href = 'https://www.monterrey.gob.mx';
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 2000);
        return () => clearTimeout(timer);
    }, [onClose]);

    MySwal.fire({
        title: "Mensaje Importante:",
        html: "<p class='swal-text'>Para liberación de vehículos detenidos, acudir previamente a la Dirección de Tránsito de Monterrey en Abraham Lincoln 300, esquina Refugio Velázquez, Col. Morelos CP 64330. Para dudas sobre su adeudo, llámenos al 81 8305 0900 Ext. 1978.</p></br><p class='decide'>¿Desea continuar en la página?</p>",
        confirmButtonText: "Continuar",
        showDenyButton: true,
        denyButtonText: "Salir",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        customClass: {
            title: "titleC text-white",
            popup: "popupClass",
            confirmButton: "btn bg-green-500",
            denyButton: "btn bg-red-500",
        },
        didOpen: () => {
            const titleEl = document.querySelector(".titleC");
            if (titleEl) {
                (titleEl as HTMLElement).style.backgroundColor = "#233252";
                (titleEl as HTMLElement).style.padding = "1rem";
                (titleEl as HTMLElement).style.borderRadius = "0.5rem 0.5rem 0 0";
            }
        }
    }).then((result) => {
        if (result.isConfirmed) {
            onClose();
        } else if (result.isDenied) {
            redirigir();
        }
    });
}

export function PaymentProcessModal({ isOpen, onClose }: ModalProps) {
    useEffect(() => {
        if (!isOpen) return;

        Swal.fire({
            title: "Su pago está en proceso",
            icon: "info",
            html: `<p class='swal-text'>Estimado usuario, se ha detectado un intento de pago que se encuentra en proceso. 
            Si su intento de pago fue interrumpido, favor de esperar 15 minutos e intentar nuevamente, si su pago procedió correctamente, favor 
            de revisar su estado de cuenta.</p><br><p class='decide'>¿Desea continuar en la página?</p>`,
            confirmButtonText: "Continuar",
            showDenyButton: true,
            denyButtonText: "Salir",
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            customClass: {
                popup: "popupClass",
                confirmButton: "btn bg-green-500",
                denyButton: "btn bg-red-500",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                onClose();
            } else if (result.isDenied) {
                window.location.href = "https://www.monterrey.gob.mx";
            }
        });

    }, [isOpen, onClose]);

    return null;
}

export function AcceptedPayment({ isOpen, onClose }: ModalProps) {
    if (!isOpen) return null;

    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 2000);
        return () => clearTimeout(timer);
    }, [onClose]);

    MySwal.fire({
        title: "Adeudo Pagado Exitosamente",
        icon: "success",
        html: "<p class='swal-text'>Estimado usuario, el pago de su adeudo ha sido realizado, favor de revisar su estado de cuenta o correo electrónico.</p><br><p class='decide'>¿Desea continuar en la página?</p>",
        confirmButtonText: "Continuar",
        showDenyButton: true,
        denyButtonText: "Salir",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        iconColor: "#0a5c00",
        customClass: {
            popup: "popupClass bg-green-100",
            confirmButton: "btn bg-green-500",
            denyButton: "btn bg-red-500",
        },
    }).then((result) => {
        if (result.isConfirmed) {
            onClose();
        } else if (result.isDenied) {
            window.location.href = "https://www.monterrey.gob.mx";
        }
    });
}

export function NotFoundPlate({ isOpen, onClose }: ModalProps) {
    if (!isOpen) return null;

    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 2000);
        return () => clearTimeout(timer);
    }, [onClose]);

    MySwal.fire({
        title: "Placa sin registros de infracciones",
        icon: "success",
        html: "<p class='swal-text'>No se encontraron multas o infracciones asociadas a la placa que ingresaste. Si tienes dudas, verifica que los datos sean correctos e intenta de nuevo.</p>",
        confirmButtonText: "Continuar",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        iconColor: "#0a5c00",
        customClass: {
            popup: "popupClass bg-red-100",
            confirmButton: "btn bg-red-500",
        },
    }).then((result) => {
        if (result.isConfirmed) {
            onClose();
        }
    });
}

export function DenyPayment({ isOpen, onClose }: ModalProps) {
    if (!isOpen) return null;

    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 2000);
        return () => clearTimeout(timer);
    }, [onClose]);

    MySwal.fire({
        title: "Su pago se encuentra bloqueado",
        icon: "error",
        html: "<p class='swal-text'>Estimado usuario, el pago para las multas de su placa se encuentra bloqueado, favor de acudir a Mesa de Hacienda a realizar su pago</p>",
        confirmButtonText: "Cerrar",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        iconColor: "#ec5353",
        customClass: {
            popup: "popupClass bg-red-100",
            confirmButton: "btn bg-red-500",
        },
    }).then((result) => {
        if (result.isConfirmed) {
            onClose();
        }
    });
}
